import { useState } from 'react';
import { Link } from 'react-router-dom';
import { allSanstha } from '../data/santhaData';
import logo from '../assets/logo.png';
import CustomSelect from '../components/CustomSelect';
import './Sanstha.css';

const areas = ['All Areas', 'Valsad City', 'Bulsar', 'Pardi', 'Vapi', 'Umargam', 'Dharampur', 'Kaprada', 'Navsari', 'Bilimora', 'Gandevi'];

export default function Sanstha() {
  const [search, setSearch] = useState('');
  const [area, setArea] = useState('All Areas');
  const [verifiedOnly, setVerifiedOnly] = useState(false);

  const filtered = allSanstha.filter((s) => {
    const matchSearch = s.name.toLowerCase().includes(search.toLowerCase()) || s.area.toLowerCase().includes(search.toLowerCase());
    const matchArea = area === 'All Areas' || s.area === area;
    const matchVerified = !verifiedOnly || s.verified;
    return matchSearch && matchArea && matchVerified;
  });

  return (
    <div className="sanstha-page">
      <div className="page-hero">
        <div className="container">
          <div className="badge">Valsad District</div>
          <h1>Mandal Directory</h1>
          <p>All registered Ganpati Mahotsav Mandal across Valsad district — find, connect and collaborate.</p>
        </div>
      </div>

      <section>
        <div className="container">
          {/* Filters */}
          <div className="sanstha-filters card">
            <div className="filter-search">
              <span className="search-icon">🔍</span>
              <input
                type="text"
                placeholder="Search by name or area..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <CustomSelect options={areas} value={area} onChange={setArea} />
            <label className="verified-toggle">
              <input type="checkbox" checked={verifiedOnly} onChange={(e) => setVerifiedOnly(e.target.checked)} />
              <span>Verified Only</span>
            </label>
          </div>

          <div className="sanstha-count">
            Showing <strong>{filtered.length}</strong> of {allSanstha.length} mandal
          </div>

          {/* Grid */}
          <div className="sanstha-grid">
            {filtered.map((s) => (
              <div key={s.id} className="sanstha-card card">
                <div className="sanstha-header">
                  <div className="sanstha-icon">
                    <img src={logo} alt="Aarambh" style={{ height: '48px', objectFit: 'contain' }} />
                  </div>
                  {s.verified && <span className="verified-badge">✓ Verified</span>}
                </div>
                <h3 className="sanstha-name">{s.name}</h3>
                <div className="sanstha-meta">
                  <span>📍 {s.area}</span>
                  <span>📅 Est. {s.year}</span>
                  <span>👥 {s.members} members</span>
                </div>
                <div className="sanstha-activities">
                  {s.activities.map((a) => (
                    <span key={a} className="activity-tag">{a}</span>
                  ))}
                </div>
                <div className="sanstha-actions">
                  <Link to={`/sanstha/${s.id}`} className="btn-outline" style={{ fontSize: '0.85rem', padding: '8px 18px' }}>View Details</Link>
                  <Link to="/donate" className="btn-primary" style={{ fontSize: '0.85rem', padding: '8px 18px' }}>Donate</Link>
                </div>
              </div>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="no-results">
              <div style={{ fontSize: '3rem' }}>🔍</div>
              <h3>No mandal found</h3>
              <p>Try adjusting your search or filter criteria.</p>
            </div>
          )}

          <div className="sanstha-cta card">
            <div>
              <h3>Don't see your Mandal?</h3>
              <p>Register your Ganpati Mahotsav Mandal and join the Valsad network today — it's free!</p>
            </div>
            <Link to="/register" className="btn-primary">Register Now</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
